import { Injectable } from '@angular/core';

@Injectable({
    providedIn: 'root',
})
export class UsersService {
    saveUser(data: string) {
        localStorage.setItem('user', data);
    }

    getUser() {
        return localStorage.getItem('user');
    }

    deleteUser() {
        localStorage.removeItem('user');
    }
}
